import _ from "lodash";
import axios from "axios";
import { genericRequestErrorHandler, SISI_API_URL } from "../..";

export async function fetchMembersAutocomplete({
  params,
  errorFunc = (error) => genericRequestErrorHandler(error),
}) {
  try {
    const result = await axios.get(
      `${SISI_API_URL}/crm/members/autocomplete/`,
      { params }
    );
    return _.get(result, "data", []);
  } catch (error) {
    errorFunc({ error });
    return null;
  }
}
